package com.schoolconnect.app.feature.config

import androidx.compose.runtime.Composable
import com.schoolconnect.app.feature.schoolconfig.SchoolConfigFeatureRoute

@Composable
fun ConfigFeatureRoute(
    onBack: () -> Unit,
    roleLabel: String = "School Admin",
    roleSubtitle: String = "School configuration",
    onChangeRole: () -> Unit = onBack,
    onLogout: () -> Unit = {}
) {
    SchoolConfigFeatureRoute(
        roleLabel = roleLabel,
        roleSubtitle = roleSubtitle,
        onChangeRole = onChangeRole,
        onLogout = onLogout,
        onBack = onBack
    )
}
